import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import SearchPage from "@/pages/SearchPage";
import HistoryPage from "@/pages/HistoryPage";
import SearchDetailPage from "@/pages/SearchDetailPage";
import ProspectsPage from "@/pages/ProspectsPage";
import SmsTemplatesPage from "@/pages/SmsTemplatesPage";
import CommercialValuesPage from "@/pages/CommercialValuesPage";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <AuthProvider>
        <BrowserRouter>
          <Toaster />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                <Route path="/" element={<SearchPage />} />
                <Route path="/recherches" element={<HistoryPage />} />
                <Route path="/recherches/:id" element={<SearchDetailPage />} />
                <Route path="/prospects" element={<ProspectsPage />} />
                <Route path="/modeles-sms" element={<SmsTemplatesPage />} />
                <Route path="/coefficients" element={<CommercialValuesPage />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
